export default __webpack_public_path__ + "static/media/The Haven of War.a8efb1a8.jpg";